import styled from 'styled-components';

export const Wrapper = styled.div<{
  $isSelected: boolean;
  $isValidationPending: boolean;
  $isInvalid: boolean;
  $isHidden: boolean;
  $isDuplicate: boolean;
}>`
  display: flex;
  padding: 12px;
  width: 100%;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 4px;
  color: ${({ $isHidden, theme }) => ($isHidden ? theme.colors.black6 : theme.colors.black9)};
  border: 1px solid
    ${({ theme, $isSelected, $isValidationPending, $isInvalid, $isDuplicate }) =>
      $isDuplicate || $isInvalid
        ? $isSelected
          ? theme.colors.red6
          : theme.colors.red4
        : $isValidationPending
        ? $isSelected
          ? theme.colors.orange6
          : theme.colors.orange4
        : $isSelected
        ? theme.colors.green6
        : theme.colors.black4};
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  min-height: 70px;
  transition: all 0.2s ease-in-out;
  box-shadow: ${({ theme, $isSelected, $isValidationPending, $isInvalid, $isDuplicate }) =>
    $isSelected
      ? $isDuplicate || $isInvalid
        ? `0px 0px 1px 2px ${theme.colors.red2}`
        : $isValidationPending
        ? `0px 0px 1px 2px ${theme.colors.orange2}`
        : `0px 0px 1px 2px ${theme.colors.green2}`
      : 'none'};
`;

export const IndexWrapper = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black6};
`;

export const TitleWrapper = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  flex: 1 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IconWrapper = styled.div`
  width: 16px;
`;
